var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppinCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_331_3341)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 11.166C4 10.6137 4.44772 10.166 5 10.166C5.55228 10.166 6 10.6137 6 11.166C6 11.7183 5.55228 12.166 5 12.166C4.44772 12.166 4 11.7183 4 11.166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 11.166C9.5 10.6137 9.94772 10.166 10.5 10.166C11.0523 10.166 11.5 10.6137 11.5 11.166C11.5 11.7183 11.0523 12.166 10.5 12.166C9.94772 12.166 9.5 11.7183 9.5 11.166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 1.16602C0.5 0.889873 0.723858 0.666016 1 0.666016H3C3.23831 0.666016 3.44351 0.834208 3.49028 1.06789L3.91022 3.16602H12C12.149 3.16602 12.2903 3.23248 12.3852 3.34729C12.4802 3.46211 12.5191 3.6133 12.4911 3.75968L11.6904 7.95843C11.6219 8.30372 11.434 8.61389 11.1598 8.83465C10.8869 9.0543 10.5458 9.1715 10.1957 9.16602H5.34432C4.99419 9.1715 4.6531 9.0543 4.38024 8.83465C4.10612 8.61398 3.91832 8.30397 3.84966 7.95885C3.84964 7.95871 3.84969 7.95899 3.84966 7.95885L3.01439 3.78562C3.01101 3.77181 3.00819 3.75778 3.00598 3.74355L2.59016 1.66602H1C0.723858 1.66602 0.5 1.44216 0.5 1.16602ZM4.11036 4.16602L4.83042 7.76361C4.85328 7.87871 4.9159 7.9821 5.00731 8.05568C5.09872 8.12927 5.21309 8.16836 5.33042 8.16611L5.34 8.16602H10.2L10.2096 8.16611C10.3269 8.16836 10.4413 8.12927 10.5327 8.05568C10.6237 7.98244 10.6861 7.87967 10.7093 7.76521L11.3956 4.16602H4.11036Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_331_3341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.5 0.666016)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppinCart);
export default __webpack_public_path__ + "static/media/shoppin-cart.c469e13710845fa68fcd804eea4d08a6.svg";
export { ForwardRef as ReactComponent };